import React, { Component } from "react";
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogFooterButton
} from "@cdk-uip/react-dialog";

export default class UnsuspendUserDialog extends Component {
  constructor(props) {
    super(props);
    this.unsuspendUser = this.unsuspendUser.bind(this);
  }

  unsuspendUser(e) {
    this.props.unsuspendUser(this.props.userId, this.props.email);
    this.props.onClose(e);
  }

  render() {
    const { open, onClose, userName, uid } = this.props;
    return (
      <Dialog open={open} onCancel={onClose}>
        <DialogHeader>
          Are you sure you want to Activate user account of {userName} ?
        </DialogHeader>
        <DialogFooter>
          <DialogFooterButton onClick={e => this.unsuspendUser(e)}>
            Yes
          </DialogFooterButton>
          <DialogFooterButton onClick={onClose}>No</DialogFooterButton>
        </DialogFooter>
      </Dialog>
    );
  }
}
